import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAssessmentForm from "../../forms/CreateOrUpdateAssessmentForm";
import { AssessmentResponseDto } from "../../shared/dtos/assessment/AssessmentResponseDto";

interface UpdateAssessmentModalProps {
  open: boolean;
  onClose: () => void;
  assessment: AssessmentResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateAssessmentModal: React.FC<UpdateAssessmentModalProps> = ({
  open,
  onClose,
  assessment,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${assessment?.name || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateAssessmentForm
      isEditing
      assessment={assessment}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateAssessmentModal;
